import Comment from './Comment'

export default function generateShapedComments(comments) {
  const Comments = comments
    .filter(comment => comment.notes !== '')
    .map(comment => Comment(comment))
  return Comments
}
